import CodeRain from "../../CodeRain";
import logo from '../../../assets/imagens/logo_ACB.png'
import Typing from "../../../components/ui/Typing";

import './CabecalhoForm.css'
export default function CabecalhoForm ({textTyping}) {
    return(
        <div>
            <div className="containerCodeRain">
                <CodeRain />
            </div>

            <div className="cabecalhoForm">
                <img width={100} src={logo} />

                    <Typing
                        text={textTyping}
                        speed={130}
                        />
                    
                    <p>
                        Preencha com seus dados e faça parte do jogo!
                    </p>
                </div>

        </div>
    )
}